import { render } from "./EntryAnswerResultWait.vue?vue&type=template&id=63c0c09e"
import script from "./EntryAnswerResultWait.vue?vue&type=script&lang=js"
export * from "./EntryAnswerResultWait.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src882003474/src/vote-screen-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__